import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from '@perval/shared';

@Component({
  selector: 'app-contact-section',
  templateUrl: './contact-section.component.html',
  styleUrls: ['./contact-section.component.scss'],
})
export class ContactSectionComponent implements OnInit {
  URL_CONTACT_FORM_FRESHSALES!: string;
  iframeHeight: number = 600;

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data?.type === 'iframe-resize') {
      this.iframeHeight = event.data.height;
    }

    if (event.data?.redirect && event.data.url) {
      window.location.href = event.data.url;
    }
  }

  ngOnInit(): void {
    this.URL_CONTACT_FORM_FRESHSALES =
      environment.freshHost + '?redirectParent=true';
  }
}
